import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

export default function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    if (sectionId === 'contact') {
      navigate('/contact');
      return;
    }
    
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setIsMobileMenuOpen(false);
  };

  const menuItems = [
    { id: 'top', label: 'トップ' },
    { id: 'company', label: '会社概要' },
    { id: 'business', label: '事業内容' },
    { id: 'recruit', label: '採用情報' },
    { id: 'news', label: 'お知らせ' },
  ];

  const handleNavClick = (id: string) => {
    if (id === 'contact') {
      scrollToSection('contact');
    } else if (id === 'top') {
      navigate('/');
    } else {
      navigate(`/${id}`);
    }
  };

  return (
    <nav className="bg-white border-b border-gray-200">
      {/* 上段:ロゴと会社名 */}
      <div className="w-full px-6 lg:px-12 xl:px-16 border-b bg-white" style={{ borderColor: '#e0e0e0', boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03)' }}>
        <div className="py-1.5 lg:py-2.5 flex justify-between items-center lg:pl-[5cm]">
          <Link to="/" className="inline-flex items-center gap-3 hover:opacity-80 transition-opacity duration-200 min-w-0">
            <img
              src="https://static.readdy.ai/image/0947c5c75234eb0df91750a621813a72/9e07b5b9673a019b56521029222db271.jpeg"
              alt="株式会社鈴電エンジニア"
              className="h-7 lg:h-8 w-auto flex-shrink-0"
            />
            <span className="text-sm sm:text-base md:text-lg lg:text-xl font-semibold text-gray-900 tracking-tight whitespace-nowrap" style={{ fontFamily: "'Yu Gothic', 'YuGothic', sans-serif" }}>
              株式会社鈴電エンジニア
            </span>
          </Link>

          {/* モバイルメニューボタン */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden flex flex-col items-center p-1.5 bg-black text-white hover:bg-gray-800 transition-colors duration-200 cursor-pointer flex-shrink-0 ml-auto"
            aria-label="メニュー"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
            <span className="text-[10px] font-medium tracking-wider">MENU</span>
          </button>
        </div>
      </div>

      {/* 下段:グローバルナビゲーション */}
      <div className="w-full border-t border-gray-300 hidden lg:block bg-white">
        <div className="px-6 lg:px-12 xl:px-16">
          <div className="flex items-center justify-center">
            <div className="h-6 w-px bg-gray-300"></div>
            {menuItems.map((item, index) => (
              <div key={item.id} className="flex items-center">
                <button
                  onClick={() => handleNavClick(item.id)}
                  className="px-12 py-3 text-sm font-bold text-gray-700 hover:text-gray-900 hover:bg-gray-50 transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  {item.label}
                </button>
                {index < menuItems.length - 1 && (
                  <div className="h-6 w-px bg-gray-300"></div>
                )}
              </div>
            ))}
            <div className="h-6 w-px bg-gray-300 ml-0"></div>
            <button
              onClick={() => handleNavClick('contact')}
              className="px-12 py-3 text-sm font-bold text-gray-700 hover:text-gray-900 hover:bg-gray-50 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              お問い合わせ
            </button>
            <div className="h-6 w-px bg-gray-300"></div>
          </div>
        </div>
      </div>

      {/* モバイルメニュー */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-black">
          <div className="divide-y divide-gray-700">
            {menuItems.map((item) => (
              <button
                key={item.id}
                onClick={() => handleNavClick(item.id)}
                className="block w-full text-left px-6 py-4 text-sm font-medium text-white hover:bg-gray-800 transition-all duration-200 cursor-pointer"
              >
                {item.label}
              </button>
            ))}
            <button
              onClick={() => handleNavClick('contact')}
              className="block w-full text-left px-6 py-4 text-sm font-medium text-white hover:bg-gray-800 transition-all duration-200 cursor-pointer"
            >
              お問い合わせ
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
